import {action, makeObservable, observable} from 'mobx'
import type {FreeTimeSlot} from '@/src/features/functional-testing/core/dto'
import {Dayjs} from 'dayjs'

export const FormTestingStep = {
  SelectTypeTesting: 1,
  SelectLab: 2,
  SelectDay: 3,
  Finish: 4,
} as const

type MayBeOneOfStep = ValuesOf<typeof FormTestingStep>

export class FormTestingStore {
  @observable
  step: MayBeOneOfStep = FormTestingStep.SelectTypeTesting

  @observable
  lastReached: MayBeOneOfStep = FormTestingStep.SelectTypeTesting

  @observable
  typeId?: Id

  @observable
  shopId?: Id

  @observable
  date?: Dayjs

  @observable.ref
  time?: FreeTimeSlot

  constructor() {
    makeObservable(this)
  }

  @action.bound
  setShopId(id?: Id) {
    this.shopId = id
  }

  @action.bound
  setTypeId(id?: Id) {
    this.typeId = id
  }

  @action.bound
  setDate(date?: Dayjs) {
    this.date = date
  }

  @action.bound
  setTime(time?: FreeTimeSlot) {
    this.time = time
  }

  @action.bound
  setStep(step: MayBeOneOfStep) {
    this.step = step
  }

  // Продвижение после выбора; ре-селекция сбрасывает данные нижележащих шагов
  @action.bound
  advance(step: MayBeOneOfStep) {
    this.step = step

    if (step > this.lastReached) {
      this.lastReached = step
      return
    }

    this.resetAfter(step)
  }

  @action.bound
  init(step: MayBeOneOfStep, lastReached: MayBeOneOfStep) {
    this.step = step
    this.lastReached = lastReached
  }

  private resetAfter(step: MayBeOneOfStep) {
    if (step <= FormTestingStep.SelectLab) {
      this.shopId = undefined
    }
    if (step <= FormTestingStep.SelectDay) {
      this.date = undefined
      this.time = undefined
    }
  }
}
